export default "__VITE_ASSET__BIXwjhcL__"